import { render, staticRenderFns } from "./HomeLogo.vue?vue&type=template&id=94e6a234"
import script from "./HomeLogo.vue?vue&type=script&lang=js"
export * from "./HomeLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports